import { render, staticRenderFns } from "./HeaderNavMegaMenu.vue?vue&type=template&id=be7587c4&scoped=true&"
import script from "./HeaderNavMegaMenu.vue?vue&type=script&lang=js&"
export * from "./HeaderNavMegaMenu.vue?vue&type=script&lang=js&"
import style0 from "./HeaderNavMegaMenu.vue?vue&type=style&index=0&id=be7587c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be7587c4",
  null
  
)

export default component.exports